module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-as"
  }, [(!_vm.user) ? _c('button', {
    on: {
      "click": _vm.doLogin
    }
  }, [_c('img', {
    attrs: {
      "src": "https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Login with google")])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('button', {
    staticClass: "clickable logout",
    on: {
      "click": _vm.doLogout
    }
  }, [_c('img', {
    staticClass: "photo",
    attrs: {
      "src": _vm.user.photoURL
    }
  }), _vm._v(" "), _c('span', [_vm._v("Logout " + _vm._s(_vm.user.displayName))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-298ff92a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FirebaseAuth.vue
// module id = 545
// module chunks = 1